import { deleteField } from "firebase/firestore";

// Builds the Firestore payload for a fund EDIT, written with { merge: true }.
//
// Property-present write discipline: a field is included in the payload ONLY
// when the submitting form actually manages it. The two live edit forms manage
// different optional fields — InlineFundForm has `endDate` but no `donorReason`;
// the legacy AddFund form has `donorReason` but no `endDate`. Writing a field a
// form does not manage would clobber the stored value under `{ merge: true }`,
// so absent fields are omitted (merge preserves them) and present-but-empty
// fields are cleared deliberately (deleteField()/null).
export const buildFundEditPayload = (fundEntryData, user) => {
  const payload = {
    fundName: fundEntryData.fundName?.trim(),
    fundNumber: fundEntryData.fundNumber?.toString().trim(),
    isRestricted: fundEntryData.isRestricted ? true : false,
    userMadeChange: user.uid,
  };

  // donorReason — the donor-friendly name shown instead of fundName.
  if ("donorReason" in fundEntryData) {
    const trimmed = fundEntryData.donorReason?.trim();
    payload.donorReason = trimmed ? trimmed : deleteField();
  }

  // endDate — auto-close date for temporary sub-funds (dayjs in form state).
  if ("endDate" in fundEntryData) {
    payload.endDate = fundEntryData.endDate
      ? fundEntryData.endDate.toDate()
      : null;
  }

  return payload;
};
